import { CSSResultGroup, TemplateResult, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { OutlineElement } from 'src/components/base/outline-element/outline-element';
import { SlotController } from 'src/components/controllers/slot-controller';
import { MobileController } from '../../controllers/mobile-controller';

/**
 * Custom element for displaying different content based on the device type.
 * @element idb-multi-component
 */
@customElement('idb-multicomponent')
export class IdbMultiComponent extends OutlineElement {
  static styles: CSSResultGroup = [];

  private mobileController = new MobileController(this, 'lg');
  slots = new SlotController(this, true);

  /**
   * Renders the template based on the device type.
   * @returns The rendered template.
   */
  render(): TemplateResult {
    return html`
      ${
        this.mobileController.isMobile
          ? html`
      <slot name="mobile"></slot>`
          : html`<slot name="desktop"></slot>`
      }`;
  }
}
